import React from 'react';
import styles from './TabsContent.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const TermoAcumulatorTAPDescription = () => {

  return (
    <div className={styles.container}>
      <p className={styles.mainTitle}><span className={styles.highlight}>Termo-acumulator plat</span> cu schimbătoare de căldură</p>
      <p className={styles.text}>
        Rezervoarele tampon sunt proiectate pentru funcționarea continua fără supraveghere, cu condiția respectării regulilor de instalare și funcționare.
      </p>
      <p className={styles.text}>
        Termoizolarea: țesătura hidro-rezistenta Cordura – material ușor și rezistent.
      </p>
      <p className={styles.text}>
        Pentru izolarea boilerului este folosita vata minerala ISOVER.
      </p>
      <p className={styles.text}>
        Datorită caracteristicilor de țesere a pânzei și de aplicare a unui strat de poliuretan și clorură de polivinil pe interiorul țesăturii, care împiedică colectarea murdăriei între fibre, are o rezistență excelentă la uzură și apă.
      </p>
      <p className={styles.text}>
        Rezistenta excelenta la expunerea razelor ultraviolete și decolorare.
      </p>
    </div>
  );
};